module.exports = __webpack_public_path__ + "static/media/10.question.c785616f.mp4";